import { useLayoutEffect } from 'react';
import Picker from '@emoji-mart/react';
import { init } from 'emoji-mart';
import emojiData from '@emoji-mart/data';
import en from '@emoji-mart/data/i18n/en.json';
import zh from '@emoji-mart/data/i18n/zh.json';
import { useLanguage } from '../i18n/provider';

export default function EmojiPicker({ onEmojiSelect }: {
  onEmojiSelect: (emoji: { native: string }) => void;
}) {
  const { effectiveLocale } = useLanguage();
  const locale = effectiveLocale === 'zh-CN' ? 'zh' : 'en';
  const i18n = effectiveLocale === 'zh-CN' ? zh : en;

  useLayoutEffect(() => {
    // Emoji Mart reads a global dictionary when its scheduled picker update renders.
    // Supplying bundled data makes that dictionary replacement synchronous.
    void init({ data: emojiData, locale, i18n });
  }, [locale, i18n]);

  return <Picker data={emojiData} locale={locale} i18n={i18n} onEmojiSelect={onEmojiSelect} previewPosition="none" />;
}
